/* eslint-disable import/no-anonymous-default-export */
import axios from 'axios'
import { API_ENDPOINTS } from 'constants'

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  getAboutUsDetails: () => {
    return axios.get(API_ENDPOINTS.GET_ABOUT_US, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
  },
}
